import Dropdown from "app/components/Dropdown";
import { useBoardsActions } from "app/containers/Features/containers/Boards/components/useBoardsActions";
import { selectUserFormData } from "app/redux/selector";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectDraftBoardForm } from "../../../../../components/Settings/redux/selector";
import { GroupByTypeEnum } from "../../../../../types";
import { selectTicketGroups } from "../../../../Tickets/redux/selector";
import { ticketGroupsActions } from "../../../../Tickets/redux/slice";

import AddTicketGroupModal from "../../AddTicketGroupModal";
import HiddenGroupItem from "./HiddenGroupItem";
import InfoText from "./InfoText";
import RenderTrigger from "./RenderTrigger";

import { BoardViewType } from "app/types";
import { TicketGroup } from "../../../../Tickets/types";

interface Props {
  type: BoardViewType;
  minTableWidth?: number;
}

const Index: React.FC<Props> = ({ type, minTableWidth }) => {
  const dispatch = useDispatch();

  const [isGroupModalOpen, setIsGroupModalOpen] = React.useState(false);

  const groupData = useSelector(selectTicketGroups);
  const { groupBy, _id: boardId } = useSelector(selectDraftBoardForm);
  const { selectedProjectId } = useSelector(selectUserFormData);

  const { updateBoardsGroupsJson } = useBoardsActions(selectedProjectId);

  const hiddenGroups = groupData?.filter((g) => !g?.isVisible) ?? [];

  const onHideGroup = (group: TicketGroup) => {
    dispatch(
      ticketGroupsActions.updateGroupActions({
        ...group,
        isVisible: true,
      }),
    );

    updateBoardsGroupsJson(boardId, () => {});
  };

  const shouldShow =
    groupBy === GroupByTypeEnum.CUSTOM_TITLES || hiddenGroups.length > 0;

  return (
    <div className="relative">
      {shouldShow && (
        <Dropdown
          className="!z-40"
          trigger={
            <RenderTrigger
              viewType={type}
              minTableWidth={minTableWidth as number}
            />
          }
          projectInfoIcon={
            <InfoText
              groupBy={groupBy}
              onAddNewGroup={() => setIsGroupModalOpen(true)}
              hasDataVisible={hiddenGroups.length > 0}
            />
          }
          menuItems={hiddenGroups.map((group) => ({
            label: <HiddenGroupItem group={group} groupBy={groupBy} />,
            action: () => onHideGroup(group),
          }))}
        />
      )}

      {isGroupModalOpen && (
        <AddTicketGroupModal
          onClose={() => setIsGroupModalOpen(false)}
          isEditGroup={false}
        />
      )}
    </div>
  );
};

export default Index;
